import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./components/LanguageContext";
import App from './App';

const basename = process.env.PUBLIC_URL || "/";

// Simple loading component
const LoadingFallback = () => (
  <div style={{ 
    position: 'fixed', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)'
  }}>
    Loading...
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter 
    basename={basename}
    future={{ 
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <LanguageProvider>
      <Suspense fallback={<LoadingFallback />}>
        <App />
      </Suspense>
    </LanguageProvider>
  </BrowserRouter>
);

